/**
 * Lolli Lifting homepage redesign (2A) — range rail progress.
 * Progressive enhancement only: without this script (or without
 * IntersectionObserver support) the CSS fallback already shows every
 * bar at a legible 30% ink opacity. Here we mark the section as
 * "enhanced" and light up the bar matching whichever card is most in
 * view as the rail is swiped.
 */
(() => {
  if (!('IntersectionObserver' in window)) return;

  document.querySelectorAll('[data-range-rail]').forEach((rail) => {
    const section = rail.closest('.lolli-range');
    if (!section) return;
    const progress = section.querySelector('[data-range-progress]');
    if (!progress) return;
    const cards = Array.from(rail.querySelectorAll('[data-range-card]'));
    const bars = Array.from(progress.querySelectorAll('.lolli-range__bar'));
    if (!cards.length || cards.length !== bars.length) return;

    progress.setAttribute('data-enhanced', '');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = cards.indexOf(entry.target);
          if (index === -1) return;
          bars.forEach((bar, i) => bar.classList.toggle('is-active', i === index));
        });
      },
      { root: rail, threshold: 0.6 }
    );

    cards.forEach((card) => observer.observe(card));
  });
})();
